/*
 * Analog Theme
 *
 * Use this file to listen for the theme's Javascript events. Keeping your custom
 * Javascript in this file makes it easier to update Analog. To use this file, open
 * snippets/head-scripts.liquid and uncomment the custom.events.js script line.
 *
 * Commerce events use Shopify's standard storefront events (names prefixed
 * "shopify:"). Theme UI events keep the "theme:" prefix. The full list is in
 * the theme docs, and the reference is at
 * https://shopify.dev/docs/api/storefront-events-and-actions
 *
 * Migrating from the old theme:* commerce events? Each block below names the
 * old event it replaces.
 */

// Below are example event listeners. They listen for events that Analog
// fires in order to make it easier for you to add customizations.

async function onThemeEvent(events) {
  // Wait for Alpine to be initialized if it has not been already
  if (!window.Alpine) {
    await new Promise((resolve) =>
      window.addEventListener("alpine:initialized", resolve)
    );
  }
  Object.entries(events).forEach(([event, callback]) => {
    window.addEventListener(event, callback);
  });
}
function dispatchThemeEvent(event, detail) {
  window.dispatchEvent(new CustomEvent(event, { detail }));
}

onThemeEvent({
/* Size guide drawer events */
  "theme:size-guide-drawer:open": () => {
    Alpine.store("drawer").isOpen = true;
    Alpine.store("drawer").type = "size-guide";
  },
  "theme:size-guide-drawer:close": () => {
    if (Alpine.store("drawer").type === "size-guide") {
      Alpine.store("drawer").isOpen = false;
    }
  },
});

// To CHANGE the cart from custom code, use Shopify's standard actions instead
// of calling /cart/add.js yourself - the theme's drawer, icon, and cart
// sections all react on their own:
//
//   await Shopify.actions.updateCart({ lines: [{ merchandiseId: 12345, quantity: 1 }] });
//   await Shopify.actions.openCart();
